<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Cadastro de Empresa
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="6">
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="empresa.nome"
                  label="Nome"
                  clearable
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-text-field
                  v-model.trim="empresa.cpfcnpj"
                  label="CPF/CNPJ"
                  clearable
                  :rules="[rules.required]"
                  v-mask="'##.###.###/####-##'"
                  required
                  @change="validarPropriedade(empresa.cpfcnpj, 2)"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="empresa.id === 0" class="mb-5">
              <v-col cols="12">
                <v-select
                  :items="grupos"
                  label="Grupo"
                  item-text="nome"
                  item-value="id"
                  v-model="filtro.grupoID"
                  required
                  @change="grupoEmpresaChange()"
                >
                  <template template v-slot:selection="{ item }">
                    <div>
                      <v-icon>{{ item.icone }}</v-icon>
                      <span>{{ `  ${item.nome}` }}</span>
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div>
                      <v-icon>{{ item.icone }}</v-icon>
                      <span>{{ `  ${item.nome}` }}</span>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <div v-if="empresa.id === 0">
              <h4>Dados para Cadastro da Empresa</h4>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="empresa.dataInicioVigencia"
                    label="Inicio Data Vigencia"
                    clearable
                    type="date"
                    :required="filtro.grupoID != null"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  v-for="prop in empresa.propriedades"
                  :key="prop.id"
                >
                  <v-text-field
                    v-if="prop.propriedadeInteligenteID == 2"
                    :label="prop.nome"
                    v-model.trim="empresa.cpfcnpj"
                    v-mask="'##.###.###/####-##'"
                    disabled
                    :required="filtro.grupoID != null"
                    @change="
                      validarPropriedade(
                        prop.valor,
                        prop.grupoPropriedade.propriedadeInteligenteID
                      )
                    "
                  ></v-text-field>
                  <v-text-field
                    v-else-if="prop.propriedadeInteligenteID"
                    :label="prop.nome"
                    v-bind:v-model="prop.valor"
                    v-mask="adicionarMascara(prop.propriedadeInteligenteID)"
                    :required="filtro.grupoID != null"
                    @change="
                      validarPropriedade(
                        prop.valor,
                        prop.grupoPropriedade.propriedadeInteligenteID
                      )
                    "
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :label="prop.nome"
                    clearable
                    :required="filtro.grupoID != null"
                    v-model="prop.valor"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div v-if="empresa.id !== 0">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="empresa.dataVigenciaFim"
                    label="Fim Data Vigencia"
                    clearable
                    type="date"
                    :required="filtro.grupoID != null"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <p>
              <v-btn @click="voltar" color="error" large>Voltar</v-btn>
              <v-btn
                @click="salvar"
                color="primary"
                large
                class="ml-2"
                :disabled="saving || block"
                >Salvar</v-btn
              >
            </p>
          </v-container>
        </v-form>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col>
        <h4>Departamentos com Acesso</h4>
        <v-divider></v-divider>
        <v-treeview
          v-if="departamentos && empresa.departamentos"
          v-model="empresa.departamentos"
          :items="departamentos"
          :selection-type="selectionType"
          selectable
          return-object
          open-all-on-load
        ></v-treeview>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { SET_LOADING } from "@/store/config.module";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  name: "empresaCadastro",
  data() {
    var dataVigencia = new Date(),
      mes = "" + (dataVigencia.getMonth() + 1),
      dia = "" + dataVigencia.getDate(),
      ano = dataVigencia.getFullYear();

    if (mes.length < 2) mes = "0" + mes;
    if (dia.length < 2) dia = "0" + dia;

    return {
      grupos: [],
      filtro: {
        grupoID: 0,
      },
      valid: false,
      saving: false,
      selectionType: "independent",
      cliente: {},
      block: false,
      empresa: {
        id: 0,
        clienteID: 0,
        nome: "",
        cpfcnpj: "",
        departamentos: [],
        grupoID: 0,
        dataInicioVigencia: `${ano}-${mes}-${dia}`,
        propriedades: [],
      },
      departamentos: [],
      open: ["public"],
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
    };
  },
  components: {
    TelaLoading,
  },
  methods: {
    alteraçãoCNPJ() {
      if (this.filtro.grupoID != null) {
        this.empresa.propriedades.forEach((x) => {
          if (x.propriedadeInteligenteID) {
            switch (x.propriedadeInteligenteID) {
              case 1:
                x.valor = this.empresa.cpfcnpj;
                break;
              case 2:
                x.valor = this.empresa.cpfcnpj;
                break;
              default:
                break;
            }
          }
        });
      }
    },
    removerMascara() {
      this.empresa.cpfcnpj = this.empresa.cpfcnpj.match(/\d/g).join("");
      this.alteraçãoCNPJ();
    },
    adicionarMascara(item) {
      let mascara = "";
      switch (item) {
        case 1:
          mascara = "###.###.###-##";
          break;
        case 2:
          mascara = "##.###.###/####-##";
          break;
        default:
          mascara = "";
          break;
      }

      return mascara;
    },
    async validarPropriedade(propriedadeValor, propriedadeInteligenteID) {
      try {
        this.saving = true;
        const { data: result } = await ApiService.get(
          "entidade",
          `validar/propriedade/${propriedadeValor
            .match(/\d/g)
            .join(
              ""
            )}/propriedadeInteligenteID/${propriedadeInteligenteID}/cliente/${
            this.cliente.id
          }`
        );
        if (!result.success) {
          SweetAlert.sweetAlertError(result.errors);
          this.block = true;
        } else this.block = false;
        this.saving = false;
      } catch (ex) {
        this.saving = false;
      }
    },
    async listarDepartamentos() {
      await ApiService.get(
        "departamento/gettreeviewbyclienteid/" + this.cliente.id,
        "",
        { filtrarUsuario: true }
      ).then(({ data }) => {
        if (data.success) this.departamentos = data.data;
        else SweetAlert.sweetAlertError(data.errors);
      });
    },

    salvar() {
      let self = this;
      this.empresa.grupoID = this.filtro.grupoID;
      this.removerMascara();
      if (this.$refs.form.validate()) {
        this.saving = true;

        if (this.empresa.departamentos.length === 0) {
          this.saving = false;
          return Swal.fire({
            position: "center",
            icon: "error",
            title:
              "Para continuar é preciso selecionar, ao menos, um Departamento.",
            showConfirmButton: false,
            timer: 2500,
          });
        }

        if (this.empresa.id === 0) {
          return new Promise((resolve) => {
            ApiService.post("empresa", this.empresa).then(({ data }) => {
              resolve(data);

              if (data.success) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Empresa Cadastrada com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "empresa" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        } else {
          if (self.empresa.dataVigenciaFim !== null) {
            Swal.fire({
              title: "Vigência Fim",
              text: "A alteração da vigência final, afeta também as entidades. Deseja prosseguir?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Sim, pode prosseguir!",
            }).then(function (resp) {
              if (resp.value) return self.editarEmpresa();
              self.saving = false;
            });
          } else {
            return self.editarEmpresa();
          }
        }
      }
    },

    editarEmpresa() {
      let self = this;
      return new Promise((resolve) => {
        ApiService.put("empresa/" + this.empresa.id, this.empresa).then(
          ({ data }) => {
            resolve(data);

            if (data.success) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Empresa Alterada com Sucesso!",
                showConfirmButton: false,
                timer: 1500,
              }).then(function () {
                self.$router.push({ name: "empresa" });
              });
            } else SweetAlert.sweetAlertError(data.errors);
          }
        );
      }).finally(() => (this.saving = false));
    },

    async buscarEmpresa(id) {
      const { data: result } = await ApiService.get("empresa/" + id);

      if (result.success) {
        this.empresa = result.data;
        this.filtro.grupoID = this.empresa.grupoID;
        this.$store.commit(SET_LOADING, false);
      } else SweetAlert.sweetAlertError(result.errors);
    },

    async listaPropriedades() {
      const { data: result } = await ApiService.get(
        "grupoPropriedade/getByGrupoID/" + this.filtro.grupoID
      );

      if (result.success) {
        this.empresa.propriedades = result.data;
        this.empresa.propriedades.forEach((x) => {
          x.valor = null;
        });
        this.$store.commit(SET_LOADING, false);
      } else SweetAlert.sweetAlertError(result.errors);
    },

    voltar() {
      history.go(-1);
    },

    async grupoEmpresaChange() {
      this.empresa.grupoID = this.filtro.grupoID;
      await this.listaPropriedades();
    },
    async listaGruposEmpresa() {
      const { data: result } = await ApiService.get(
        "grupo/getbyclienteid/gruposEmpresa/" + this.cliente.id
      );

      this.page = 1;
      this.itemsPerPage = 10;

      if (result.success) {
        this.grupos = result.data;
      } else SweetAlert.sweetAlertError(result.errors);
    },
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Empresas" }]);
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.empresa.clienteID = this.cliente.id;
    await this.listaGruposEmpresa();
    await this.listarDepartamentos();

    if (this.$route.params.id !== undefined)
      await this.buscarEmpresa(this.$route.params.id);

    this.$store.commit(SET_LOADING, false);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Empresa, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
